import Vue from 'vue';
import AsyncComputed from 'vue-async-computed';
import axios from 'axios';
import moment from 'moment';
import 'array-flat-polyfill';
import './polyfills/replaceAll';
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome';
import router from '@/routers/index';
import App from './App.vue';
import store from './store';
import Default from './layouts/Default.vue';
import NoSidebar from './layouts/NoSidebar.vue';
import Empty from './layouts/Empty.vue';


Vue.use(AsyncComputed);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);

Vue.config.productionTip = false;

Vue.component('default-layout', Default);
Vue.component('no-sidebar-layout', NoSidebar);
Vue.component('empty-layout', Empty);

Vue.filter('formatDateMMDDYYYY', (value, def) => {
  if (value) {
    return moment(value).format('MM/DD/YYYY');
  }
  return def || 'N/A';
});

// Like formatDateMMDDYYYY but parseZone keeps the offset written in the value
// (e.g. "+05:30") instead of converting to the browser's local time, so the date
// is never shifted across midnight by the viewer's timezone. Use for values that
// represent a calendar date carrying a source offset (e.g. sourceRefreshDate).
Vue.filter('formatDatePreserveZone', (value, def) => {
  if (value) {
    const m = moment.parseZone(value);
    if (m.isValid()) return m.format('MM/DD/YYYY');
  }
  return def || 'N/A';
});

Vue.filter('formatDateMMDDYYYYHHMM', (value) => {
  if (value) {
    return moment(value).format('MM/DD/YYYY hh:mm:ssa');
  }
  return 'N/A';
});

Vue.filter('formatTime', (value) => {
  if (value) {
    return moment(value).format('hh:mm A');
  }
  return 'N/A';
});
Vue.filter('BlankPlaceHolder', (value) => {
  if (value) {
    return value;
  }
  return '\u00A0';
});

axios.defaults.baseURL = '/uid/api/v1/';
axios.defaults.headers = {
  'Cache-Control': 'no-cache',
  'Pragma': 'no-cache',
  'Expires': '0',
};
// configure router guards
router.beforeEach((to, from, next) => {
  const needsAuth = !to.meta.public && !store.state.user;
  if (needsAuth) {
    next({
      path: '/landing',
      query: { r: to.fullPath },
    });
  } else {
    document.title = to.meta.title || process.env.VUE_APP_DEFAULT_TITLE;
    next();
  }
});

// configure a response interceptor to refresh the session timer
axios.interceptors.response.use((response) => {
  clearTimeout(store.state.sessionTimer);
  if (store.state.user) {
    const timeout = 1000 * ((store.state.timeout) - 60);

    store.state.sessionTimer = setTimeout(() => {
      store.state.sessionWarning = true;
    }, timeout);
  }
  return response;
});


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
